import React from 'react';

const AnnexColumns = () => (
  <tr>
    <th>Actions</th>
    <th>Numéro</th>
    <th>Produit</th>
    <th>Quantité</th>
    <th>Dilution</th>
    <th>
      Matériel
      <br />
      Complémentaire
    </th>
    <th>Quantité</th>
    <th>Dilution</th>
  </tr>
);

export default AnnexColumns;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/AnnexColumns.js